import * as Actions from "store/actions/app/sorts.actions"
import { toggleIdInArray } from "utils/toggle-id-in-array"
import { addOrUpdateObjectInArray } from "utils/add-or-update-object-in-array"

const initialState = {
  loading_sorts_with_subsorts: false,
  sorts_with_subsorts: [],

  saving_sort: false,
  saved_sort: false,

  deleting_sort: false,
  deleted_sort: false,

  updating_sort_ids: [],
}

const sortsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_SORTS_WITH_SUBSORTS: {
      return {
        ...state,
        loading_sorts_with_subsorts: action.payload.loading ?? false,
        sorts_with_subsorts: action.payload.data ?? state.sorts_with_subsorts
      }
    }
    case Actions.SAVE_SORT: {
      return {
        ...state,
        saving_sort: action.payload.saving ?? false,
        saved_sort: action.payload.saved ?? false,
        sorts_with_subsorts: action.payload.data
          ? addOrUpdateObjectInArray(state.sorts_with_subsorts, action.payload.data, 'clase_id', true)
          : state.sorts_with_subsorts
      }
    }
    case Actions.TOGGLE_SORT_STATUS: {
      return {
        ...state,
        updating_sort_ids: toggleIdInArray(state.updating_sort_ids, action.payload.updating_id),
        sorts_with_subsorts: action.payload.data
          ? addOrUpdateObjectInArray(state.sorts_with_subsorts, action.payload.data, 'clase_id')
          : state.sorts_with_subsorts
      }
    }
    case Actions.DELETE_SORT: {
      return {
        ...state,
        deleting_sort: action.payload.deleting ?? false,
        deleted_sort: action.payload.deleted ?? false,
        sorts_with_subsorts: state.sorts_with_subsorts.filter(sort => sort.clase_id !== action.payload.deleted_id)
      }
    }
    case Actions.UPDATE_SORT_WITH_SUBSORTS: {
      return {
        ...state,
        sorts_with_subsorts: action.payload.data
          ? addOrUpdateObjectInArray(state.sorts_with_subsorts, action.payload.data, 'clase_id')
          : state.sorts_with_subsorts
      }
    }
    default: {
      return state
    }
  }
}
export default sortsReducer
